import { cloneDeep, get, isEmpty, merge } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'
import { TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { fillDependence, generateServices, globalErrorHandler, permissionPresets } from '@/utils'

import { tasksFilter } from '@/components/services/tasks/utils'

import render from './render'

export default function(options = {}) {
  return {
    name: Services.tasks,

    mixins: [
      generateServices({
        name: Services.tasks,

        async inputFilter(result) {
          const payload = get(result, 'data.sending.payload')

          if (payload && (payload.file || payload.image || payload.audio)) {
            const [ id1, id2 ] = (payload.file || payload.image || payload.audio).split('/')

            result.$FileId = id2 || id1

            await fillDependence.call(this, result, {
              service: 'storage',
              permissions: [ 'me', 'reseller', true ],
              pathToId: '$FileId',
              pathToObject: 'File',
              outputPath: 'File',
              requestParams: {
                query: {
                  return: 'meta'
                }
              }
            })
          }

          if (TaskTypes['payments:recurrent'] === result.type) {
            const recurrentPaymentId = get(result, 'data.recurrentPaymentId')

            await fillDependence.call(this, result, {
              service: Services.recurrentPayments,
              permissions: permissionPresets.resellerUp,
              pathToId: 'data.recurrentPaymentId',
              outputPath: 'data',
              picks: [ 'amount', 'frequency' ]
            })

            Object.assign(result.data, { recurrentPaymentId })
          }

          return result
        },
        outputFilter(result) {
          if (result.frequency === 'once') {
            result.data.endsAt = undefined
          }
          result.type = options.taskType
          result.state = TaskStates.scheduled

          return result
        },

        find: {
          defaultFilter: merge({}, cloneDeep(tasksFilter), options.defaultFilter),
          alwaysUpdateFromWebSocket: true
        },
        get: false,
        update: false,
        remove: false
      })
    ],

    props: {
      headers: {
        type: Array,
        default: () => {
          return []
        }
      }
    },

    data() {
      return {
        showDialog: false,

        filter: merge({}, cloneDeep(tasksFilter), options.defaultFilter)
      }
    },

    computed: {
      canCreateTasksAsResellerUp() {
        return this.checkPermissions(`advanced.${Services.tasks}.create`, permissionPresets.resellerUp)
      },

      computedHeaders() {
        return options.headers || this.headers
      },

      presets() {
        return options.presets
      },

      createDataIsValid() {
        return this.restData[Services.tasks].create.state !== 'loading' && this.restData[Services.tasks].create.isValid
      }
    },

    watch: {
      filter: {
        handler() {
          this.restData[Services.tasks].find.filter = this.filter
        },
        deep: true
      }
    },

    mounted() {
      if (!isEmpty(this.$route.params)) {
        this.filter.createdAt = this.$route.params.createdAt
        this.restData[Services.tasks].find.filter.createdAt = this.$route.params.createdAt
      } else {
        this.rest[Services.tasks].find()
      }
    },

    methods: {
      async createTask() {
        if (this.createDataIsValid) {
          try {
            const result = await this.rest.tasks.create(this.restData[Services.tasks].create.data)
            if (result) {
              this.showDialog = false
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    },

    render
  }
}
